import { BaseService } from './base-service';

class PoolclueService extends BaseService {
  /**
   *  获取用户线索池
   *
   * @author 曲世杰
   * @param  {Object} data
   * @returns
   * @memberof PoolclueService
   */

  getPoolclue(params) {
    return this.request({
      method: 'get',
      url: `/pool/clue`,
      params
    });
  }

  /**
   *  线索池分配
   *
   * @author 曲世杰
   * @param  {Object} data
   * @returns
   * @memberof PoolclueService
   */

  poolDistribute(data) {
    return this.request({
      method: 'post',
      url: `/pool/clue/distribute`,
      data
    });
  }

  /**
   *  线索池领取
   *
   * @author 曲世杰
   * @param  {Object} data
   * @returns
   * @memberof PoolclueService
   */

  poolTake(data) {
    return this.request({
      method: 'post',
      url: `/pool/clue/take`,
      data
    });
  }

  /**
   *  线索池转移
   *
   * @author 曲世杰
   * @param  {Object} data
   * @returns
   * @memberof PoolclueService
   */
  poolTo(data) {
    return this.request({
      method: 'post',
      url: `/pool/clue/toPool`,
      data
    });
  }

  /**
   *  是否线索池管理员
   *
   * @author 曲世杰
   * @param  {Object} data
   * @returns
   * @memberof PoolclueService
   */
  isManager(params) {
    return this.request({
      method: 'get',
      url: `/pool/isManager`,
      params
    });
  }
  /**
   *  根据线索池id查询相关的部门和人员
   *
   * @author 曲世杰
   * @param  {Object} data
   * @returns
   * @memberof PoolclueService
   */

  getPoolDepartAndUser(params) {
    return this.request({
      method: 'get',
      url: `/pool/clue/deptAndUser`,
      params
    });
  }
}

export const poolClueService = new PoolclueService();
